import React, { useState } from 'react';

import { ActionIcon, Box, Flex, Paper, Text, TextInput, TextInputProps } from '@mantine/core';
import { IconPlus, IconTrash } from '@tabler/icons-react';

interface BubblePopupMessagesInputProps extends Omit<TextInputProps, 'onChange' | 'value'> {
  value: string[];
  onChange: (value: string[]) => void;
}

export function BubblePopupMessagesInput({ value, onChange, ...props }: BubblePopupMessagesInputProps) {
  const [input, setInput] = useState('');

  const handleAddMessage = () => {
    onChange([...value, input]);
    setInput('');
  };

  const handleRemoveMessage = (message: string) => {
    onChange([...value.filter((m) => m !== message)]);
  };

  return (
    <Box>
      <Flex direction="row" align="center" gap="md">
        <TextInput
          w="100%"
          value={input}
          onChange={(event) => setInput(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') handleAddMessage();
          }}
          error={props.error}
          label={props.label}
          placeholder={props.placeholder}
        />
        <ActionIcon mt={20} disabled={!input} color="dark" onClick={handleAddMessage}>
          <IconPlus />
        </ActionIcon>
      </Flex>
      {value.map((message, index) => (
        <Paper
          withBorder
          key={index}
          p={5}
          pl={10}
          my="xs"
          style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <Text>{message}</Text>
          <ActionIcon color="red" onClick={() => handleRemoveMessage(message)}>
            <IconTrash />
          </ActionIcon>
        </Paper>
      ))}
    </Box>
  );
}
